import React from 'react';
import './commonButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faFilter ,fas } from '@fortawesome/free-solid-svg-icons'

const CommonButton = (props) => {

    let checkIcon = (icon) => {
        switch(icon){
            case 'faGear': 
                return(<FontAwesomeIcon icon={faGear} />);
             break;
             case 'faFilter': 
                return(<FontAwesomeIcon icon={faFilter} />);
             break;
            default:

        }
    };

    return (
        <button disabled={(props.disabled == true)?(true):(false)} type="button" onClick={props.parentCallback}
            id={props.id}
            className={` ${props.size ? "btn-resize" : "btn-fixed"} `}>
            {checkIcon(props.icon)}
        
            <strong> {props.title}</strong>
        </button >
    );

}

export default CommonButton